// Section codes are `<AREA>-<COL><ROW>`, COL in spreadsheet letters (A..Z, AA..). api/src/assets/locations-service.js
// is the authority; this mirrors it for the live preview and for reading a grid's size off its section codes.

export const MAX_SECTIONS = 500;
export const MAX_COLUMNS = 702;
export const MAX_ROWS = 999;

export function columnLetters(n: number): string {
  let out = '';
  let left = n;
  while (left > 0) {
    const r = (left - 1) % 26;
    out = String.fromCharCode(65 + r) + out;
    left = Math.floor((left - 1) / 26);
  }
  return out;
}

export function columnNumber(letters: string): number {
  let n = 0;
  for (const ch of letters) n = n * 26 + (ch.charCodeAt(0) - 64);
  return n;
}

/** Row-major, like the server returns them: A1, B1, ..., A2. */
export function sectionCodes(area: string, columns: number, rows: number, limit = Infinity): string[] {
  const out: string[] = [];
  for (let r = 1; r <= rows && out.length < limit; r += 1) {
    for (let c = 1; c <= columns && out.length < limit; c += 1) out.push(`${area}-${columnLetters(c)}${r}`);
  }
  return out;
}

/** The grid's current extent from every section code it has ever had, retired ones included. */
export function gridExtent(areaCode: string, sectionCodesOfArea: string[]): { columns: number; rows: number } {
  let columns = 0;
  let rows = 0;
  const prefix = `${areaCode}-`;
  for (const code of sectionCodesOfArea) {
    if (!code.startsWith(prefix)) continue;
    const m = /^([A-Z]+)(\d+)$/.exec(code.slice(prefix.length));
    if (!m) continue;
    columns = Math.max(columns, columnNumber(m[1]));
    rows = Math.max(rows, parseInt(m[2], 10));
  }
  return { columns, rows };
}

export const AREA_CODE_RE = /^[A-Z0-9]{2,5}$/;
